import {EyebrowRestDto} from "@/api/pharma-cms-content-page/models";
import {EyebrowStyleEnum} from "@/api/enums/eyebrow-style-enum";

/**
 * Clears the eyebrow fields that do not apply to the chosen style, in place.
 *
 * The form keeps every field around while the user switches styles, so without this the payload
 * would carry values the backend rejects or silently keeps for a style that no longer shows them.
 */
function normalizeEyebrow(eyebrow?: EyebrowRestDto | null): void {
    if (!eyebrow) {
        return;
    }

    const style = eyebrow.style_code;

    if (style === EyebrowStyleEnum.BAR) {
        eyebrow.text = null;
    } else {
        eyebrow.bar_width_code = null;
        eyebrow.bar_thickness = null;
    }

    if (style === EyebrowStyleEnum.BAR || style === EyebrowStyleEnum.PILL) {
        eyebrow.letter_spacing = null;
    }

    if (style === EyebrowStyleEnum.KICKER) {
        eyebrow.color = null;
    } else if (style === EyebrowStyleEnum.BAR || style === EyebrowStyleEnum.TAG) {
        eyebrow.text_color = null;
    }
}

export {
    normalizeEyebrow,
};
